import api from './api';

export async function getBookingStaff() {
  const response = await api.get('/booking-staff');
  return response.data;
}

export async function createBookingStaff(data) {
  const response = await api.post('/booking-staff', data);
  return response.data;
}

export async function setBookingStaffStatus(id, isActive) {
  const response = await api.patch(`/booking-staff/${id}/status`, { isActive });
  return response.data;
}
